<kt-splash-screen></kt-splash-screen>
<app-loader></app-loader>
<router-outlet></router-outlet>
<div *ngIf="IsAIChatEnable == 'true' && isDoctorOrAdmin && showChatbot">
  <ng-template #chatbotIcon>
    <div class="chatbot-icon" (click)="OpenAIChatBot()" (keydown.enter)="OpenAIChatBot()">
      <img [matTooltip]="('AIAssistant' | translate)" src="assets/media/icons/chatbot.png" alt="Chatbot" />
    </div>
  </ng-template>

  <!-- Render template -->
  <ng-container *ngTemplateOutlet="chatbotIcon"></ng-container>
</div>
<ng-template #sessionOutDialog>
  <kt-session-out *ngIf="showWarningPopup">
  </kt-session-out>
</ng-template>